import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CommunicationService } from '../services/communication.service';
import { ValidationsService } from '../services/validations.service';
import { UpdateConcessionRegistration } from './entities/update-concession-registration.';

@Injectable()
export class RegistrationService {
  companyDataFG = new FormGroup({
    company_id: new FormControl({ value: null, disabled: false }),
    company_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    tax_id: new FormControl({ value: null, disabled: false }),
    street: new FormControl({ value: null, disabled: false }, [Validators.required]),
    street_number: new FormControl({ value: null, disabled: false }, [Validators.required]),
    postcode: new FormControl(
      {
        value: null,
        disabled: false,
      },
      [Validators.required, ValidationsService.maxLengthValidator()]
    ),
    city: new FormControl({ value: null, disabled: false }, [Validators.required]),
    telephone: new FormControl({ value: null, disabled: false }, [Validators.required]),
    ceo: new FormControl({ value: null, disabled: false }, [Validators.required]),
    email: new FormControl({ value: null, disabled: false }, [ValidationsService.emailValidator()]),
    headoffice: new FormControl({ value: null, disabled: false }, [Validators.required]),
    subsidiary: new FormControl({ value: null, disabled: false }, [Validators.required]),
    main_businesses_part_time: new FormControl({ value: null, disabled: false }),
    in_auxiliary_operation: new FormControl({ value: null, disabled: false }),
    /* registered_network_operator: new FormControl({value: null, disabled: false}, [Validators.required]),*/
    headsubsidiary: new FormControl({ value: 'hauptbetrieb', disabled: false }, [Validators.required]),
  });

  guestCompanyDataFG = new FormGroup({
    company_id: new FormControl({ value: null, disabled: false }),
    company_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    tax_id: new FormControl({ value: null, disabled: false }),
    street: new FormControl({ value: null, disabled: false }, [Validators.required]),
    street_number: new FormControl({ value: null, disabled: false }, [Validators.required]),
    postcode: new FormControl(
      {
        value: null,
        disabled: false,
      },
      [Validators.required, ValidationsService.maxLengthValidator()]
    ),
    city: new FormControl({ value: null, disabled: false }, [Validators.required]),
    telephone: new FormControl({ value: null, disabled: false }, [Validators.required]),
    ceo: new FormControl({ value: null, disabled: false }, [Validators.required]),
    email: new FormControl({ value: null, disabled: false }, [ValidationsService.emailValidator()]),
    headoffice: new FormControl({ value: null, disabled: false }, [Validators.required]),
    subsidiary: new FormControl({ value: null, disabled: false }, [Validators.required]),
    headsubsidiary: new FormControl({ value: 'hauptbetrieb', disabled: false }, [Validators.required]),
  });

  guestTechnicianDataFG = new FormGroup({
    sk_title: new FormControl({ value: null, disabled: false }, [Validators.required]),
    last_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    first_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    birthday: new FormControl({ value: null, disabled: false }, [Validators.required]),
    telephone: new FormControl({ value: null, disabled: false }, [Validators.required]),
    qualification_type: new FormControl({ value: null, disabled: false }),
    email: new FormControl({ value: null, disabled: true }, [ValidationsService.emailValidator()]),
  });

  technicianDataFG = new FormGroup({
    sk_title: new FormControl({ value: null, disabled: false }, [Validators.required]),
    last_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    first_name: new FormControl({ value: null, disabled: false }, [Validators.required]),
    birthday: new FormControl({ value: null, disabled: false }, [Validators.required]),
    telephone: new FormControl({ value: null, disabled: false }, [Validators.required]),
    qualification_type: new FormControl({ value: null, disabled: false }, [Validators.required]),
    qualification_issued_on: new FormControl({ value: null, disabled: false }),
    email: new FormControl({ value: null, disabled: true }, [ValidationsService.emailValidator()]),
  });

  checkDataFG = new FormGroup(
    {
      heating: new FormControl(false),
      gas: new FormControl(false),
      power: new FormControl(false),
      water: new FormControl(false),
      license: new FormControl(null),
    },
    this.requireOneBranch()
  );

  educationInformationDataFG = new FormGroup({
    journeyman_training_as: new FormControl({ value: null, disabled: false }),
    diploma_technician_specialization: new FormControl({ value: null, disabled: false }),
    university_or_technical_college_degree_specialty: new FormControl({ value: null, disabled: false }),
    journeyman_training_on: new FormControl({ value: null, disabled: false }),
    diploma_technician_on: new FormControl({ value: null, disabled: false }),
    university_or_technical_college_degree_on: new FormControl({ value: null, disabled: false }),
  });

  constructor(private http: HttpClient, private communicationService: CommunicationService) {}

  getTechnicianApplication(id: string | number, type: string): Observable<any> {
    return this.communicationService.getData(`technician_application?${type}=${id}`);
  }

  saveNewTechnicianApplication(saveData: any, technicianId: string): Observable<any> {
    return this.communicationService.postData(`technician_application?technician_id=${technicianId}`, saveData);
  }

  updateTechnician(updateData: any, technicianId: string): Observable<any> {
    return this.communicationService.updateData(`technician?technician_id=${technicianId}`, updateData);
  }

  saveCompany(companyData: any): Observable<any> {
    return this.communicationService.postData(`company`, companyData);
  }

  updateCompany(updateData: any, companyId: string): Observable<any> {
    return this.communicationService.updateData(`company?company_id=${companyId}`, updateData);
  }

  updateTechnicianApplication(updateData: any, taId: string): Observable<any> {
    return this.communicationService.updateData(`technician_application?ta_id=${taId}`, updateData);
  }

  updateTechnicianApplicationWithConcessionValidation(data: UpdateConcessionRegistration): Observable<any> {
    return this.communicationService.updateData(`concession-registration`, data);
  }

  requireOneBranch() {
    return formGroup => {
      if (!(formGroup.get('heating').value || formGroup.get('gas').value || formGroup.get('power').value || formGroup.get('water').value)) {
        return { required: 'at least one branch has to be selected' };
      }
      return null;
    };
  }
}
